import { useRef } from 'react';

const usePerformantSingleHotKeysScope = () => {
  const enabledScopeRef = useRef<[string]>(['']);

  const singleEnabledScope = enabledScopeRef.current;

  const enableScope = (newScope: string) => {
    enabledScopeRef.current[0] = newScope;
  };

  return {
    enableScope,
    singleEnabledScope,
  };
};

export default usePerformantSingleHotKeysScope;
